/**
 * Syslog 설정
 *
 * @since 2018-10-30
 * @author jupil.Go <devp018>
 */

import {i18n} from '~/plugins/i18n'
import {CmApiPrefix as apiPrefix} from '~/utils/restApi'

const initSyslogPageData = () => {
  return {
    device_list: [],
    syslog_cm_id: 0,
    syslog_cm_sync_yn: 1,
    syslog_cm_uname: '',
    syslog_cm_desc: '',
    syslog_cm_log_sync_set: [0, 0, 0, 0, 0],
    syslog_cm_log_set: [],
    syslog_cm_log_opt_set: [],
    syslog_cm_device_model_type: 20
  }
}
const initAutoSendData = (id = 0) => {
  return {
    syslog_cm_id: id,
    syslog_cm_server_id: 0,
    syslog_cm_server_sync_yn: 0,
    syslog_cm_server_use_yn: 0,
    syslog_cm_server_addr_val: '',
    syslog_cm_server_port: 0,
    syslog_cm_server_func_type: 0,
    syslog_cm_server_form_type: 0,
    syslog_cm_server_protocol: 0,
    syslog_cm_server_desc: ''
  }
}

function makeSyncSetData (param) {
  try {
    const data = _.cloneDeep(param)
    const res = {}
    if (_.size(data) > 0) {
      data.forEach((o, index) => {
        res[`sync_set${index + 1}`] = o
      })
    } else {
      return void 0
    }
    return res
  } catch (e) {
    return void 0
  }
}

export const state = () => ({
  url: `${apiPrefix}/syslog-cm`,
  sysLogDataList: [],
  sysLogPageOrgData: {},
  sysLogPageData: initSyslogPageData(),
  autoSendList: [],
  autoSendData: initAutoSendData(),
  logInfoList: [],
  defaultList: [],
  defaultOptionList: [],
  syncData: {}
})

export const mutations = {
  initStore (state) {
    state.sysLogDataList = []
    state.sysLogPageOrgData = {}
    state.sysLogPageData = initSyslogPageData()
    state.autoSendList = []
    state.autoSendData = initAutoSendData()
    state.logInfoList = []
    state.defaultList = []
    state.defaultOptionList = []
    state.syncData = {}
  },
  clearSysLogDialog: (state) => {
    state.sysLogPageData = initSyslogPageData()
  },
  clearSyslogDeviceList (state) {
    state.sysLogPageData.device_list = []
  },
  // 서버 목록 초기화
  clearAutoSendData (state) {
    state.autoSendList = []
  },
  clearAutoSendDialog: (state) => {
    state.autoSendData = initAutoSendData(_.cloneDeep(state.sysLogPageData.syslog_cm_id))
  },

  // 리스트 조회
  setSysLogData (state, item) {
    state.sysLogDataList = _.cloneDeep(item)
  },
  setCmId (state, id) {
    state.sysLogPageData.syslog_cm_id = id
    state.autoSendData.syslog_cm_id = id
  },
  setSyncData (state, data) {
    state.syncData = _.omit(data, ['name', 'itemIndex', '_itemKey'])
    state.sysLogPageData.syslog_cm_log_sync_set = _.cloneDeep(_.values(state.syncData))
  },
  edtSyncData (state, param) {
    const data = _.flatten(param), svrID = data[0], status = data[1]
    const svrIndx = (svrID - 1) % 5
    // 동기화 value 설정
    const items = _.filter(state.autoSendList, ['syslog_cm_server_id', svrID])
    state.sysLogPageData.syslog_cm_log_sync_set[svrIndx] = (status === 1 && items.syslog_cm_server_use_yn === 1) ? 1 : 0
    state.syncData = _.cloneDeep(makeSyncSetData(state.sysLogPageData.syslog_cm_log_sync_set))
  },
  edtUseData (state, param) {
    const data = _.flatten(param), svrID = data[0], status = data[1]
    const svrIndx = (svrID - 1) % 5
    // 동기화 value 설정
    const items = _.filter(state.autoSendList, ['syslog_cm_server_id', svrID])
    state.sysLogPageData.syslog_cm_log_sync_set[svrIndx] = (items.syslog_cm_server_sync_yn === 1 && status === 1) ? 1 : 0
    state.syncData = _.cloneDeep(makeSyncSetData(state.sysLogPageData.syslog_cm_log_sync_set))
  },
  addSysLog: (state, item) => {
    state.sysLogDataList.push(item)
  },
  delSysLog: (state, itemList) => {
    for (const itemKey of itemList.syslog_cm_id_list) {
      const idx = _.findIndex(state.sysLogDataList, {syslog_cm_id: itemKey})
      if (idx >= 0) {
        state.sysLogDataList.splice(idx, 1)
      }
    }
  },
  setSysLogDialog (state, data) {
    const syslogSettings = _.cloneDeep(data)

    state.sysLogPageData.syslog_cm_id = syslogSettings.syslog_cm_id
    state.sysLogPageData.syslog_cm_uname = syslogSettings.syslog_cm_uname
    state.sysLogPageData.syslog_cm_desc = syslogSettings.syslog_cm_desc
    state.sysLogPageData.syslog_cm_sync_yn = syslogSettings.syslog_cm_sync_yn
    state.sysLogPageData.syslog_cm_device_model_type = syslogSettings.syslog_cm_device_model_type
    state.sysLogPageData.device_list = syslogSettings.device_list

    state.sysLogPageData.syslog_cm_log_sync_set = JSON.parse(syslogSettings.syslog_cm_log_sync_set)
    state.syncData = _.cloneDeep(makeSyncSetData(state.sysLogPageData.syslog_cm_log_sync_set))

    state.sysLogPageData.syslog_cm_log_set = JSON.parse(syslogSettings.syslog_cm_log_set)
    state.defaultList = state.sysLogPageData.syslog_cm_log_set
    state.logInfoList = _.cloneDeep(state.defaultList)

    state.sysLogPageData.syslog_cm_log_opt_set = JSON.parse(data.syslog_cm_log_opt_set)
    state.defaultOptionList = state.sysLogPageData.syslog_cm_log_opt_set
  },
  setSysLogOptionList (state, data) {
    state.sysLogPageData.syslog_cm_log_opt_set = _.cloneDeep(data)
    state.defaultOptionList = _.cloneDeep(state.sysLogPageData.syslog_cm_log_opt_set)
  },
  setSyslogDeviceList (state, data) {
    state.sysLogPageData.device_list = _.cloneDeep(data)
  },

  setSyslogLogEntitiesSettings (state, payload) {
    state.sysLogPageData.syslog_cm_log_set = payload

    state.defaultList = state.sysLogPageData.syslog_cm_log_set
    state.logInfoList = _.cloneDeep(state.defaultList)
  },
  // 리스트 조회
  setAutoSendData (state, item) {
    state.autoSendList = _.map(item, o => {
      if (o.syslog_cm_server_sync_yn !== 1 || o.syslog_cm_server_use_yn !== 1) {
        const svrIndx = (o.syslog_cm_server_id - 1) % 5
        state.sysLogPageData.syslog_cm_log_sync_set[svrIndx] = 0
      }
      return o
    })
    state.syncData = _.cloneDeep(makeSyncSetData(state.sysLogPageData.syslog_cm_log_sync_set))
  },
  // TAMS 미사용 (2022-01-03)
  // // 계속시 리스트 조회
  // setContinuedAutoSendData (state, item) {
  //   const cmId = _.cloneDeep(state.sysLogPageData.syslog_cm_id)
  //   const newSvrIdList = _.map(_.orderBy(item, ['syslog_cm_server_id'], ['asc']), 'syslog_cm_server_id')
  //   state.autoSendList = _.map(state.autoSendList, o => {
  //     _.set(o, 'syslog_cm_id', cmId)
  //     let svrIndx = (o.syslog_cm_server_id - 1) % 5
  //     _.set(o, 'syslog_cm_server_id', newSvrIdList[svrIndx])
  //     return o
  //   })
  // },
  setAutoSendDialog: (state, data) => {
    state.autoSendData.syslog_cm_id = data.syslog_cm_id
    state.autoSendData.syslog_cm_server_id = data.syslog_cm_server_id
    state.autoSendData.syslog_cm_server_sync_yn = data.syslog_cm_server_sync_yn
    state.autoSendData.syslog_cm_server_use_yn = data.syslog_cm_server_use_yn
    state.autoSendData.syslog_cm_server_addr_val = data.syslog_cm_server_addr_val
    state.autoSendData.syslog_cm_server_port = data.syslog_cm_server_port
    state.autoSendData.syslog_cm_server_form_type = data.syslog_cm_server_form_type
    state.autoSendData.syslog_cm_server_protocol = data.syslog_cm_server_protocol
    state.autoSendData.syslog_cm_server_func_type = data.syslog_cm_server_func_type
    state.autoSendData.syslog_cm_server_desc = data.syslog_cm_server_desc
  }
}

export const actions = {
  async checkConnection ({commit}, {target}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`/api/co/tools/connect?target=${encodeURIComponent(target)}`)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 리스트 조회
  async getSysLogData ({commit, state}, { loading = true } = {}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const ALL_SYSLOG_SETTINGS = 0
      res = await this.$axios.$get(`${state.url}/${ALL_SYSLOG_SETTINGS}`, { loading })
      if (res.code === 'ok') {
        commit('setSysLogData', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async addBeanSysLog ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(state.url, null, {loading: false, loadingShow: false, successAlert: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async getSysLog ({commit, state}, {id}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${state.url}/${id}`, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('setSysLogDialog', res.result[0])
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async addSysLog ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const params = {
        device_id_list: _.map(state.sysLogPageData.device_list, 'device_id'),
        // device_list_name: '',
        syslog_cm_desc: state.sysLogPageData.syslog_cm_desc,
        syslog_cm_id: state.sysLogPageData.syslog_cm_id,
        syslog_cm_log_set: JSON.stringify(state.logInfoList),
        syslog_cm_log_opt_set: JSON.stringify(state.sysLogPageData.syslog_cm_log_opt_set),
        syslog_cm_log_sync_set: JSON.stringify(state.sysLogPageData.syslog_cm_log_sync_set),
        syslog_cm_sync_yn: state.sysLogPageData.syslog_cm_sync_yn,
        syslog_cm_uname: state.sysLogPageData.syslog_cm_uname,
        syslog_cm_device_model_type: state.sysLogPageData.syslog_cm_device_model_type
      }

      res = await this.$axios.$put(state.url, params, {loading: false, successAlert: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async edtSysLog ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const params = {
        device_id_list: _.map(state.sysLogPageData.device_list, 'device_id'),
        // device_list_name: '',
        syslog_cm_desc: state.sysLogPageData.syslog_cm_desc,
        syslog_cm_id: state.sysLogPageData.syslog_cm_id,
        syslog_cm_log_set: JSON.stringify(state.logInfoList),
        syslog_cm_log_opt_set: JSON.stringify(state.sysLogPageData.syslog_cm_log_opt_set),
        syslog_cm_log_sync_set: JSON.stringify(state.sysLogPageData.syslog_cm_log_sync_set),
        syslog_cm_sync_yn: state.sysLogPageData.syslog_cm_sync_yn,
        syslog_cm_uname: state.sysLogPageData.syslog_cm_uname,
        syslog_cm_device_model_type: state.sysLogPageData.syslog_cm_device_model_type
      }

      res = await this.$axios.$put(state.url, params)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async delSysLog ({commit, state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const isShow = _.has(param, 'isShow') ? param.isShow : true
      const isAlert = _.has(param, 'isAlert') ? param.isAlert : true

      res = await this.$axios.$put(`${state.url}/multi`, param.idList, {
        loading: isShow,
        successAlert: isAlert,
        alertMsg: i18n.t('msg.removeApply')
      })

      if (res.code === 'ok') {
        commit('delSysLog', param.idList)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async initSyslogLogEntitiesSettings ({ commit, state }) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${state.url}/log-set/${state.sysLogPageData.syslog_cm_device_model_type}/init`, {
        loading: false,
        successAlert: false
      })

      if (res.code === 'ok') {
        commit('setSyslogLogEntitiesSettings', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async processSysLogSync ({commit, state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(`${state.url}/multi`, param, {loading: false, isNotAlert: true})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 리스트 조회
  async getAutoSendData ({commit, state}, { loading = false, init = false } = {}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      // syslog 설정 - 서버 목록 초기화
      if (init) {
        res = await this.$axios.$put(`${state.url}/${state.sysLogPageData.syslog_cm_id}/server/init`, void 0, {
          loading,
          successAlert: false
        })
      } else {
        const ALL_AUTOSEND_SETTINGS = 0
        res = await this.$axios.$get(`${state.url}/server/${state.sysLogPageData.syslog_cm_id}/${ALL_AUTOSEND_SETTINGS}`, {
          loading
        })
      }

      if (res.code === 'ok') {
        commit('setAutoSendData', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async addAutoSendData ({commit, dispatch, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const admParam = _.cloneDeep(state.autoSendData)
      delete admParam.syslog_cm_server_id
      res = await this.$axios.$post(`${state.url}/server`, admParam, {loading: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },

  async addBeanAutoSendData ({commit, dispatch, state}, {id}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const ALL_AUTOSEND_SETTINGS = 0
      res = await this.$axios.$get(`${state.url}/server/${id}/${ALL_AUTOSEND_SETTINGS}`, {
        loading: false,
        successAlert: false
      })

      if (res.code !== 'ok') return

      const beanAutoSendData = res.result
      let i = 0
      const syncYnMulti = []

      for (const item of state.autoSendList) {
        const serverId = _.cloneDeep(beanAutoSendData[i].syslog_cm_server_id)
        const params = {
          syslog_cm_id: id,
          syslog_cm_server_id: serverId, // 빈 설정 syslog_cm_server_id 추가
          // syslog_cm_server_sync_yn: item.syslog_cm_server_sync_yn, // 미지원
          syslog_cm_server_use_yn: item.syslog_cm_server_use_yn,
          syslog_cm_server_addr_val: item.syslog_cm_server_addr_val,
          syslog_cm_server_port: item.syslog_cm_server_port,
          syslog_cm_server_func_type: item.syslog_cm_server_func_type,
          syslog_cm_server_form_type: item.syslog_cm_server_form_type,
          syslog_cm_server_protocol: item.syslog_cm_server_protocol,
          syslog_cm_server_desc: item.syslog_cm_server_desc
        }

        // 서버 목록 내 동기화 여부 일괄 업데이트 인자
        syncYnMulti.push([serverId, item.syslog_cm_server_sync_yn])

        res = await this.$axios.$put(`${state.url}/server`, params, {loading: false, successAlert: false})
        if (res.code !== 'ok') {
          break
        }
        i++
      }

      const syncParams = {
        syslog_cm_server_sync_list: syncYnMulti
      }

      res = await this.$axios.$post(`${state.url}/server/multi`, syncParams, {loading: false, successAlert: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async edtAutoSendData ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const param = _.cloneDeep(state.autoSendData)
      res = await this.$axios.$put(`${state.url}/server`, param)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.meesage
    }
    return res
  },
  // 계속 추가시 서버목록 업데이트
  async edtAutoSendDataAll ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const list = _.filter(state.autoSendList, item => { return item.syslog_cm_server_addr_val !== '' })
      for (const param of list) {
        res = await this.$axios.$put(`${state.url}/server`, param, {loading: false, isNotAlert: true})
        if (res.code !== 'ok') {
          break
        }
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.meesage
    }
    return res
  },
  async processServerSync ({commit, state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(`${state.url}/server/multi`, param, {loading: false, isNotAlert: true})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async processServerUse ({commit, state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$put(`${state.url}/server/multi`, param, {loading: false, isNotAlert: true})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async finalCommand ({state}, type) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const axiosConfig = (type === 'apply') ? {applyMsg: true} : {cancelMsg: true}
      res = await this.$axios.$put(`${state.url}/${type}`, void 0, axiosConfig)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}

export const getters = {}

export const strict = false
